<template>
  <b-card class="rounded-xl border-none" no-body>
    <div v-if="!isShowCreate">
      <div class="flex justify-end">
        <base-button
          outline
          type="success"
          class="flex"
          @click="isShowCreate = true"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Create New
          Voiceblast Template
        </base-button>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="CategoryData"
      >
        <el-table-column
          label="VID"
          min-width="120px"
          prop="vid"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.vid }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Name"
          min-width="140px"
          prop="name"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.name }}</span>
          </template>
        </el-table-column>

   
         <el-table-column
          label="Voice Content"
          min-width="200px"
          prop="voiceContent"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.voiceContent }}</span>
          </template>
        </el-table-column>

         <el-table-column
          label="Status"
          min-width="140px"
          prop="status"
          sortable
        >
          <template v-slot="{ row }">
                     <base-button size="sm" type="success">{{ row.status }}</base-button>
          </template>
        </el-table-column>  

         <el-table-column
          label="Create Date"
          min-width="140px"
          prop="createDate"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.createDate }}</span>
          </template>
        </el-table-column>  

               <el-table-column
          label="Action"
          min-width="140px"
          prop="action"
          sortable
        >
          <template >
                <div class="flex items-center">
          <div class="flex items-center mr-4 cursor-pointer">
            <feather-icon
              @click="editModal = true"
              block
              icon="EditIcon"
              svgClasses="w-5"
              data-toggle="tooltip"
              data-placement="top"
              title="Edit"
            ></feather-icon>
          </div>
          <div class="flex items-center cursor-pointer">
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5"
              data-toggle="tooltip"
              data-placement="top"
              title="Delete"
            ></feather-icon>
          </div>
        </div>
          </template>
        </el-table-column> 
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </div>

    <div v-show="isShowCreate">
      <CreateVoiceBlastTemplate />
    </div>
  </b-card>
</template>
<script>
import CreateVoiceBlastTemplate from "./CreateVoiceBlastTemplate";
import CategoryData from "./CategoryData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    CreateVoiceBlastTemplate,
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,
      editModal: false,
      isShowCreate: false,
    };
  },
};
</script>
